import { Grid } from '@material-ui/core';
import AccountsPayableBlock from './AccountsPayableBlock';
import DetailedSearchBlock from './DetailedSearchBlock';
import PaymentVarianceBlock from './PaymentVarianceBlock';

function BatchListPageSidebar({ filters, setFilters, reload, total }) {
    return (
        <Grid container style={{ width: 300 }} spacing={1}>
            <DetailedSearchBlock
                filters={filters}
                setFilters={setFilters}
                reload={reload}
                total={total}
            />
            <AccountsPayableBlock />
            <PaymentVarianceBlock />
        </Grid>
    );
}

export default BatchListPageSidebar;
